import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { Select } from "antd";
import { setPage } from "../../redux/feature/AddProjectSlice";
import ButtonLoader from "../../atoms/buttonLoader";
import CreateTaskSidebar from "../../components/common/CreateTaskSideBar";
import { getTaskByProject } from "../../services/service";
import { useNavigate } from "react-router-dom";

const CreateTask = () => {
  const { Option } = Select;
  const [isLoading, setIsLoading] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const page = useSelector((state) => state.addProject.page);
  const formData = useSelector((state) => state.addProject.formData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGetTasks = async () => {
    try {
      const response = await getTaskByProject(
        parseInt(formData?.projectId),
        "",
        1,
        100
      );
      if (response?.success) {
        setTasks(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching tasks data:", error);
    }
  };
const handleClose=()=>{
 setSidebarVisible(false)
}
const handleCreateLater=()=>{
  navigate("/view-project")
  dispatch(setPage(page - 1));
}
  useEffect(() => {
    handleGetTasks();
  }, [isSidebarVisible]);

  const formik = useFormik({
    initialValues: {},
    onSubmit: async (values) => {
      if (tasks.length === 0) {
        setErrorMessage("Please add at least one task before proceeding.");
        return;
      }
      setErrorMessage("");

      try {
        setIsLoading(true);
        setTimeout(() => {
          navigate("/view-project");
        }, 2000);
      } catch (error) {
        console.error("Error creating project:", error);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="w-full h-full py-12">
      <h2 className="text-[20px] font-semibold text-[#1E3A8A] mb-6">
        {tasks?.length} Tasks Added
      </h2>

      <div className="bg-white shadow-md rounded-md max-h-[30rem] overflow-y-scroll p-6 mb-6">
        {tasks?.length > 0 ? (
          <ul className="space-y-4">
            {tasks?.map((task) => (
              <li
                key={task.id}
                className="flex justify-between items-center bg-gray-100 p-3 rounded-md shadow-sm hover:bg-gray-200"
              >
                <span className="text-[#1E3A8A] font-medium">
                  {task?.title}
                </span>
                <span className="text-sm text-gray-500">
                  Created At: {new Date(task?.createdAt).toLocaleDateString()}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-[#1E3A8A] text-center">
            No tasks have been added yet. Please create a task to see it here.
          </p>
        )}
      </div>

      {errorMessage && (
        <div className="text-red-500 text-center mb-4">{errorMessage}</div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className="flex gap-4 mt-6">
          <button
            type="button"
            className="bg-white hover:bg-orange-600 text-[#F97316] hover:text-white py-2 px-4 rounded border !border-[#F97316]"
            onClick={handleCreateLater}
          >
            {tasks?.length > 0?"Create Later":'Create Later'}
          </button>
          <button
            type="button"
            className="bg-[#F97316] hover:bg-orange-600 text-white py-2 px-4 rounded"
            onClick={() => setSidebarVisible(true)}
          >
            Create Task
          </button>
          <CreateTaskSidebar
            visible={isSidebarVisible}
            onClose={handleClose}
            projectId={parseInt(formData?.projectId)}
            from={"createProject"}
          />
        </div>

     
      </form>
    </div>
  );
};

export default CreateTask;
